import React from 'react';

const Help: React.FC = () => {
  return (
    <div>
      <h3 style={{ marginTop: 0 }}>Help</h3>
      <p style={{ color: 'var(--color-text-muted)' }}>Documentation and support resources coming soon.</p>
    </div>
  );
};

export default Help; 